import React from 'react';
import { DTSubscriptionSearchView } from '../../DTSubscriptionSearchView';
import { useDispatch, useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import { getSelectedSubscriptionsIds } from '../../../../../../selectors/tools';
import { processCommonSubscriptionFlow } from '../../../../../../actions/tools/DecisionTree/SubscriptionActions';

const DTChooseSubscriptionForCancellationNode = () => {
  const dispatch = useDispatch();
  const selectedSubscriptionsIds = useSelector(getSelectedSubscriptionsIds);

  const handleNextButtonClick = () => dispatch(processCommonSubscriptionFlow());

  return (
    <DTSubscriptionSearchView
      onNextButtonClick={handleNextButtonClick}
      isNextButtonActive={!isEmpty(selectedSubscriptionsIds)}
    />
  );
};

export default DTChooseSubscriptionForCancellationNode;
